/**
 * ライセンスポーリングユーティリティ（純粋関数）
 * CheckoutSuccess ページで使用
 */

export interface PollOptions {
	/** ライセンスがアクティブか確認する非同期関数 */
	fetchActive: () => Promise<boolean>;
	/** active:true になったときに呼ばれるコールバック */
	onActive: () => void;
	/** maxRetries 回以内に active にならなかったときに呼ばれるコールバック */
	onTimeout: () => void;
	/** ポーリング間隔（ms）。デフォルト 2000 */
	intervalMs?: number;
	/** 最大リトライ回数。デフォルト 15 */
	maxRetries?: number;
}

/**
 * ポーリングを開始する。
 * @returns クリーンアップ関数（ポーリングを停止する）
 */
export function pollLicense(opts: PollOptions): () => void {
	const intervalMs = opts.intervalMs ?? 2000;
	const maxRetries = opts.maxRetries ?? 15;
	let retries = 0;
	let stopped = false;
	let timerId: ReturnType<typeof setTimeout> | null = null;

	const tick = async () => {
		if (stopped) return;

		const active = await opts.fetchActive();
		if (stopped) return;

		if (active) {
			opts.onActive();
			return;
		}

		retries += 1;
		if (retries >= maxRetries) {
			opts.onTimeout();
			return;
		}

		timerId = setTimeout(tick, intervalMs);
	};

	timerId = setTimeout(tick, intervalMs);

	return () => {
		stopped = true;
		if (timerId !== null) {
			clearTimeout(timerId);
			timerId = null;
		}
	};
}
